import React from 'react';
import classNames from '../helpers/classNames.js';
import StatusIndicator from './StatusIndicator.js';
const StatusChip = ({
  type = StatusChip.types.neutral,
  text
}) => {
  const indicator = type !== StatusChip.types.neutral ? /*#__PURE__*/React.createElement(StatusIndicator, {
    type: type
  }) : null;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('ebds-status-chip', {
      [`--type-${type}`]: true
    })
  }, indicator, text);
};
StatusChip.types = {
  success: 'success',
  danger: 'danger',
  warning: 'warning',
  neutral: 'neutral'
};
export default StatusChip;